import { useNavigate } from "react-router-dom";
import Input, { FileInput, required, submitForm, useTextInput } from "../../../../components/input";
import { api, s3 } from "../../../../env";
import { useState } from "react";
import LoadingButton from "../../../../components/LoadingButton";
import Title from "../../../../components/Title";

export default function CreateResource() {
    const navigate = useNavigate()

    const [file, setFile] = useState(undefined)
    const [loading, setLoading] = useState(false)

    const createForm = {
        name: useTextInput("Resource Name", "label", [required])
    }

    const handleFileChange = (file) => {
        setFile(file)
    }

    const handleMetaData = () => {
        const meta = submitForm(createForm)
        if (!meta) return
        setLoading(true)
        console.log(file.type)
        api.post('/resources/upload-url', {...meta, type: file.type})
            .then(res => {
                handleUpload(res.data.url)
            })
            .catch(err => {})
    }
    
    const handleUpload = (url) => {
        s3.put(url, file, { headers: { "Content-Type": file.type || "application/octet-stream" }})
            .then(res => {
                setLoading(false)
                navigate('../..')
            })
            .catch(err => { 
                setLoading(false) 
                navigate('../..')
            })
    }

    return(<div className="standard-padding page-xl-centered showing">
        <Title className={'v-spacer-xs'}>Create Resource</Title>
        <div className="card flex columns gap-xs">
            <Input state={createForm.name}/>
            <FileInput onChange={handleFileChange}/>
            <div className="flex justify-end">
                <LoadingButton className={'solid-accent'} label={'Upload'} loading={loading} onClick={handleMetaData}/> 
            </div>
        </div>
    </div>)
}